<script>
import {defineComponent} from 'vue'
import {ElMessage, ElMessageBox, ElNotification} from "element-plus";
import moment from "moment";

export default defineComponent({
  name: "MinistryExecutionList",
  computed: {
    moment() {
      return moment
    }
  },
  data() {
    return {
      loading: false,
      tableData: [],
      page: 1,
      totalCount: 0,
      limit: 10,
    }
  },
  methods: {
    indexMethod(index) {
      return index + (this.page - 1) * this.limit + 1
    },
    handleCurrentChange() {
      this.getMinistries();
    },
    handleSizeChange() {
      this.page = 1;
      this.getMinistries();
    },
    onClickDelete(id) {
      ElMessageBox.confirm(
          'Ma\'lumoitni o\'chirasizmi?',
          'Diqqat!',
          {
            confirmButtonText: 'Ha',
            cancelButtonText: 'Bekor qilish',
            type: 'warning',
          }
      )
          .then(() => {
            this.loading = true
            this.$http.delete(`/api/v1/ministries-execution/${id}`).then(() => {
              ElMessage({
                type: 'success',
                message: 'Muvaffaqqiyatli o\'chirildi',
              })
              this.getMinistries();
            }).catch(() => {
              ElNotification({
                type: 'error',
                title: 'Xatolik',
                message: 'Iltimos, qayta urinib ko\'ring',
              })
            }).finally(() => {
              this.loading = false
            })

          })
          .catch(() => {
            ElMessage({
              type: 'info',
              message: 'O\'chirish bekor qilindi',
            })
          })
    },

    getMinistries() {
      this.loading = true;
      this.$http.get(`api/v1/ministries-execution`, {
        params: {
          limit: this.limit,
          offset: this.limit * (this.page - 1)
        }
      }).then(({data}) => {
        this.tableData = data.data;
        this.totalCount = data.count;
      }).catch(({response}) => {
        ElNotification.error({message: response.data.message || "Ma'lumot yuklashda xatolik sodir bo'ldi. Iltimos, qayta urinib ko'ring."})
      }).finally(() => {
        this.loading = false
      })
    },
  },
  mounted() {
    this.getMinistries()
  }
})
</script>

<template>
  <div v-loading.fullscreen="loading">
    <div class="header">
      <div></div>
      <el-button type="primary" @click="$router.push({name: 'MinistryExecutionFormAdd'})">Qo'shish</el-button>
    </div>
    <el-table :data="tableData" class="table" border height="calc(100vh - 245px)">
      <el-table-column type="index" label="T/R" width="80" :index="indexMethod" align="center"/>
      <el-table-column prop="ministry" label="Vazirlik" min-width="220"/>
      <el-table-column prop="plan" label="Reja" min-width="120"/>
      <el-table-column prop="quarter" label="Chorak" min-width="80"/>
      <el-table-column prop="executed" label="Bajarilgan" min-width="200"/>
      <el-table-column prop="difference" label="Farqi" min-width="80"/>
      <el-table-column prop="percent" label="Foiz" min-width="70"/>
      <el-table-column prop="created_at" label="Yaratilgan sana" min-width="140">
        <template v-slot="scope">
          {{ moment(scope.row.created_at).format("DD.MM.YYYY") }}
        </template>
      </el-table-column>
      <el-table-column label="" width="200" align="center">
        <template #default="scope">
          <el-button type="primary" size="small"
                     @click="$router.push({name: 'MinistryExecutionFormEdit', params:{id: scope.row.id}})">Tahrirlash
          </el-button>
          <el-button type="danger" size="small"
                     @click="onClickDelete(scope.row.id)">O'chirish
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <div>Umumiy soni: {{ totalCount }}</div>
      <el-pagination
          background
          layout="sizes, prev, pager, next"
          :total="totalCount"
          v-model:page-size="limit"
          v-model:current-page="page"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<style scoped>
.header {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
  gap: 10px;
  align-items: center;
}

.pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
}
</style>
